module.exports = __webpack_public_path__ + "img/500.3a33da67.png";